import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Button } from "../../core/Buttons"

export const OrderModal = ({ isOpen, onClose, onAddToCart, selectedPackage, packageData }) => {
  console.log("Data: ", packageData);
  const [variation, setVariation] = useState("NCR");
  const [quantity, setQuantity] = useState(1);
  const [isSelected, setIsSelected] = useState(false);
  
  const decrementQuantity = () => {
    if (quantity > 1) setQuantity(quantity - 1);
    setIsSelected(true);
  };
    
  const incrementQuantity = () => {
    setQuantity(quantity + 1);
    setIsSelected(true);
  };

  const handleAddToBag = () => {
    const item = {
      prodId: packageData.prodId,
      name: packageData.prodDisplayName,
      image: packageData.image,
      description: packageData.description,
      variation,
      quantity, // plain number
      price: variation === "NCR" ? packageData.NCRPrice : packageData.OutSideNCR,
    };

    console.log("Adding to cart:", item);
    onAddToCart(item);
    onClose();
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-auto" onClose={onClose}>
        {/* ✅ BACKDROP OVERLAY (Debugged) */}
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 40 }} aria-hidden="true" />

        {/* ✅ MODAL CONTAINER */}
        <div className="flex min-h-screen items-center justify-center p-4">
          <Transition.Child
            as="div"
            enter="transition ease duration-300 transform"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="transition ease duration-300 transform"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
            className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full z-50"
          >
            <Dialog.Panel>

              {/* ✅ VARIATION SELECTION */}
              <div className="mb-4 flex items-center">
                <p className="text-gray-600 mr-4">Variation:</p>
                <div className="flex gap-2">
                    {/* NCR Button */}
                    <button
                        className={`px-4 py-2 border-2 rounded-md transition-all duration-200
                            ${variation === "NCR" ? "border-[#c22f48] bg-[#c22f48] text-white" : "border-gray-400 bg-gray-200 text-gray-600"}
                            hover:border-[#c22f48] hover:bg-[#fff5f7] hover:text-black`}
                        onClick={() => setVariation("NCR")}
                        >
                        NCR
                    </button>

                    {/* Outside NCR Button */}
                    <button
                        className={`px-4 py-2 border-2 rounded-md transition-all duration-200
                            ${variation === "Outside NCR" ? "border-[#c22f48] bg-[#c22f48] text-white" : "border-gray-400 bg-gray-200 text-gray-600"}
                            hover:border-[#c22f48] hover:bg-[#fff5f7] hover:text-black`}
                        onClick={() => setVariation("Outside NCR")}
                        >
                        Outside NCR
                    </button>
                </div>
              </div>
              {/* ✅ QUANTITY SELECTOR - FINAL NA TO! */}
              <div className="mb-4 flex items-center">
                <p className="text-gray-600 mr-4">Quantity:</p>
                <div className="flex items-center gap-0 border border-red-500 rounded-md overflow-hidden">
                    <button
                        className="px-3 py-1 border-r border-red-500 text-red-600 font-bold"
                        onClick={decrementQuantity}
                    >
                        −
                    </button>
                    <span className="px-4 py-1 text-red-600 font-bold">
                        {quantity}
                    </span>
                    <button
                        className="px-3 py-1 border-l border-red-500 text-red-600 font-bold"
                        onClick={incrementQuantity}
                    >
                        +
                    </button>
                </div>
              </div>

              {/* ✅ ADD TO BAG BUTTON */}
              <div className="flex justify-end mt-4">
                <Button className="w-32 h-9 text-base px-4" onClick={handleAddToBag}>
                    Add to Bag
                </Button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
